if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select && select.addEventListener('change', (e) => {
        const value = e.target.value
        const form = select.closest('[data-localization-form]')
        const input = form.querySelector('input[data-localization-input]')
        input && input.setAttribute('value', value)
        input && form.submit()
      });
    }
  }
  customElements.define('m-localization-form', MLocalizationForm);
}
if (!customElements.get("localization-form")) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('#localization-select');
      const form = this.querySelector('.localization-form')
      select && select.addEventListener('change', (e) => {
        const value = e.target.value
        const input = form.querySelector('input[name="country_code"]')
        input && input.setAttribute('value', value)
      });
    }
  }
  customElements.define('localization-form', LocalizationForm);
}